<template>
  <!-- eslint-disable prefer-standard-components/no-vuetify-inputs -->
  <v-col
    :cols="cols"
    :lg="lg"
    :md="md"
    :sm="sm"
  >
    <v-row dense>
      <v-col
        :class="labelClass"
        cols="12"
      >
        <span>{{ $bct(message) }}</span>
        <template v-if="mandatory">
          <required-indicator />
        </template>
      </v-col>

      <v-col>
        <v-select
          @update:model-value="handleUpdateModelValue"
          :items="colorOptions"
          :model-value="localValue"
          data-cy="labeled-color-select"
          data-testid="labeled-color-select"
          variant="filled"
          hide-details
          tile
          v-bind="filteredAttrs"
        >
          <template #item="{ item, props: selectProps }">
            <v-list-item v-bind="selectProps">
              <template #append>
                <v-avatar
                  :color="item.value"
                  size="20"
                />
              </template>
            </v-list-item>
          </template>
          <template #selection="{ item }">
            <span
              v-text="item.title.toUpperCase()"
              class="me-3"
            />
            <v-avatar
              :color="item.value"
              size="20"
            />
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-divider
      v-if="dividedBottom"
      class="mt-4 mb-2"
    />
  </v-col>
</template>

<script setup>
import colors from 'vuetify/util/colors';
import { onUpdated } from 'vue';

import attrsOmitDataPrefix from '@/shared/utils/filteredAttrs';
import propsToRefs from '@/shared/utils/propsToRefs';
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';
import useLabeledField from '@/shared/composables/useLabeledField';

const emit = defineEmits(useLabeledField.emits);
defineExpose({ emit }); // Attrs and emit are used in composable, this is included for linter

const $bct = inject('translator');

const localValue = defineModel({ type: String });

const props = defineProps({
  dividedBottom: Boolean,
  mandatory: Boolean,
  message: {
    type: String,
    default: null,
  },
  ...useLabeledField.props,
});

const { labelClass, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

const colorOptions = Object.values(colors).map((value) => value.lighten2);

const attrs = useAttrs();
const filteredAttrs = ref(attrsOmitDataPrefix(attrs));

onUpdated(() => {
  filteredAttrs.value = attrsOmitDataPrefix(attrs);
});
</script>
